import cx from 'classnames'
import * as React from 'react'

import Accordion from '../../components/Accordion/Accordion'
import Contact from '../../components/Contact/Contact'
import FooterInfo from '../../components/FooterInfo/FooterInfo'
import FooterLinkList from '../../components/FooterLinkList/FooterLinkList'
import FooterSoMe from '../../components/FooterSoMe/FooterSoMe'
import MediaQuery from '../../components/MediaQuery/MediaQuery'
import type { FooterLinkListViewModel } from '../../view-models/FooterLinkListViewModel'
import type { ImageViewModel } from '../../view-models/ImageViewModel'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import styles from './footer-style.css'

type Props = {
  heading?: string
  text?: string
  image?: ImageViewModel
  soMe?: {
    facebook?: LinkViewModel
    linkedIn?: LinkViewModel
    youtube?: LinkViewModel
  }
  contact?: {
    phoneNumber?: string
    text?: string
    linkList?: Array<LinkViewModel>
    header?: string
  }
  infoLinks?: Array<LinkViewModel>
  info?: string
  linkLists: {
    links: Array<FooterLinkListViewModel>
    header?: string
  }
}
type State = {}

class Footer extends React.Component<Props, State> {
  static displayName = 'Footer'
  static defaultProps = {}

  render() {
    const { heading, text, image, infoLinks, info, linkLists, contact, soMe } = this.props

    return (
      <MediaQuery defaultMatches={true} query={'(min-width: 769px)'}>
        {(matches) =>
          matches ? (
            <footer className={styles.footer}>
              <div className={styles.top}>
                <FooterSoMe
                  heading={heading}
                  text={text}
                  image={image}
                  soMe={soMe}
                  className={styles.soMe}
                />
                {contact && (
                  <Contact
                    phoneNumber={contact.phoneNumber}
                    text={contact.text}
                    linkList={contact.linkList}
                    className={styles.contact}
                  />
                )}
              </div>
              <FooterInfo infoLinks={infoLinks} info={info} />
              {linkLists && <FooterLinkList lists={linkLists.links} />}
            </footer>
          ) : (
            <footer className={cx(styles.mobileFooter, 'footer')}>
              <FooterSoMe
                heading={heading}
                text={text}
                image={image}
                soMe={soMe}
                className={styles.soMe}
              />
              {contact && (
                <div className={styles.contact}>
                  <Accordion
                    items={[
                      {
                        header: contact.header,
                        component: (
                          <Contact
                            phoneNumber={contact.phoneNumber}
                            text={contact.text}
                            linkList={contact.linkList}
                          />
                        ),
                      },
                    ]}
                  />
                </div>
              )}
              <FooterInfo infoLinks={infoLinks} info={info} />
              <div>
                <Accordion
                  items={[
                    {
                      header: linkLists && linkLists.header && linkLists.header,
                      component: <FooterLinkList lists={linkLists.links} />,
                    },
                  ]}
                />
              </div>
            </footer>
          )
        }
      </MediaQuery>
    )
  }
}

export default Footer